import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";


const Chapter3 = () => {
const selectedLanguage = useSelector((state) => state.language.language);
      const [language, setLanguage] = useState(SinhalaData[0]);
    
        useEffect(() => {
            switch (selectedLanguage.value) {
              case "english":
                setLanguage(EnglishData[0]);
                break;
              case "tamil":
                setLanguage(TamilData[0]);
                break;
              default:
                setLanguage(SinhalaData[0]);
                break;
            }
          }, [selectedLanguage]);
        

    return (
        <>
           

             {/* Chapter 3 */}
                <section id="section3" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">
                        {language.chapter3Title}
                    </h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter3Paragraph1}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter3Paragraph2}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter3Paragraph3}
                    </p>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter3Paragraph4}
                    </p>

                    <h3 className="drivers-handbook-subheading"> {language.subheading7}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.subheading7List1}</li>
                        <li>{language.subheading7List2}</li>
                        <li>
                            {language.subheading7List3}
                        </li>
                        <li>{language.subheading7List4}</li>
                        <li>{language.subheading7List5}</li>
                        <li>{language.subheading7List6}</li>
                        <li>{language.subheading7List7}</li>
                        <li>{language.subheading7List8}</li>
                    </ul>

            
                    <p className="drivers-handbook-paragraph">
                        {language.paragraph24}
                    </p>

                    <h3 className="drivers-handbook-subheading">
                        {language.subheadingsubheading8}
                    </h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.subheading8List1}</li>
                        <li>{language.subheading8List2}</li>
                        <li>
                            {language.subheading8List3}
                        </li>
                        <li>දි{language.subheading8List4}</li>
                        <li>
                            {language.subheading8List5}
                        </li>
                        <li>
                            {language.subheading8List6}
                        </li>
                        <li>
                            {language.subheading8List7}
                        </li>
                        <li>
                            {language.subheading8List8}
                        </li>
                    </ul>
                </section>
        </>
    )

}

export default Chapter3;
